import _ from 'lodash'

function naturalSortBy(collection, iteratee) {
    let index = 0

    return _.map(_.map(collection, (value, key, list) => {
        return {
            value: value,
            index: index++,
            criteria: typeof iteratee === 'function' ? iteratee(value, key, list) : value[iteratee]
        }
    }).sort((left, right) => {
        const a = left.criteria
        const b = right.criteria
        return naturalSort(a, b)
    }), 'value')
}

function naturalSort(a, b) {
    const aParts = String(a ?? '').match(/(\d+|\D+)/g) || []
    const bParts = String(b ?? '').match(/(\d+|\D+)/g) || []

    for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
        const aPart = aParts[i]
        const bPart = bParts[i]

        if (aPart !== bPart) {
            const aIsNumber = !isNaN(Number(aPart))
            const bIsNumber = !isNaN(Number(bPart))

            if (aIsNumber && bIsNumber) {
                return Number(aPart) - Number(bPart)
            } else if (aIsNumber) {
                return -1
            } else if (bIsNumber) {
                return 1
            } else {
                return aPart.localeCompare(bPart, undefined, {
                    sensitivity: 'base' // ignores case AND accents (diacritics)
                })
            }
        }
    }

    return aParts.length - bParts.length // If all parts are equal, sort by length
}

export default naturalSortBy
